import React from 'react'
import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles(() => ({
  container: {
    position: 'relative',
  },
  blocker: {
    position: 'absolute',
    top: '0',
    left: '0',
    width: '100%',
    height: '100%',
    zIndex: '9999999999999',
  },
}))

export const InteractionBlocker = ({ children }) => {
  const { container, blocker } = useStyles()

  return (
    <div className={container}>
      <div className={blocker} />
      {children}
    </div>
  )
}
